import React from 'react';
import { Grid } from '@mui/material';

import { BooleanDescField, CurrencyTextField, TagsSelectField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function MarketingActionsDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="maac_tags"
					label={t('DETAILS_MARKETINGACTIONS_FIELD_TAGS')}
					value={props.model.maac_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WARNING */}
				<BooleanDescField
					name="maac_warning_desc"
					label={t('DETAILS_MARKETINGACTIONS_FIELD_WARNING')}
					value={props.model.maac_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BLOCKED */}
				<BooleanDescField
					name="maac_blocked_desc"
					label={t('DETAILS_MARKETINGACTIONS_FIELD_BLOCKED')}
					value={props.model.maac_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* EXPENSES */}
				<CurrencyTextField
					name="maac_expenses"
					label={t('DETAILS_MARKETINGACTIONS_FIELD_EXPENSES')}
					value={props.model.maac_expenses}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
